import api from '../token2';

export const ListRegime = async () => {
  try {
    const response = await api.post('/getRegime');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

